import { Check, Smartphone } from 'lucide-react';
import { useState } from 'react';
import {
  GlassCard,
  SettingsPageHeader,
  SurfacePageBody,
  SurfacePageLayout,
} from '@/design-system';
import { Commentable } from '@/shared/comments/Commentable';
import { BUTTON_PRIMARY } from '@/shared/ui-class';

export function InstallAppScene() {
  const [installing, setInstalling] = useState(false);
  const [installed, setInstalled] = useState(false);

  const handleInstall = () => {
    setInstalling(true);
    window.setTimeout(() => {
      setInstalling(false);
      setInstalled(true);
    }, 1200);
  };

  return (
    <SurfacePageLayout width="narrow">
      <Commentable name="InstallAppScene">
        <SurfacePageBody className="space-y-8" as="div">
          <SettingsPageHeader
            title="Install app"
            description="Add Foundation to your device for quick, app-like access."
          />

          <GlassCard as="section" tone="strong" className="p-5">
            {installed ? (
              <div className="flex items-center gap-3">
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-600 dark:text-emerald-400">
                  <Check className="h-5 w-5" aria-hidden />
                </div>
                <div>
                  <p className="font-medium text-zinc-900 dark:text-zinc-100">Installed</p>
                  <p className="text-sm text-muted">
                    Foundation is installed as an app on this device.
                  </p>
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--glass-surface)] text-muted">
                    <Smartphone className="h-5 w-5" aria-hidden />
                  </div>
                  <div>
                    <p className="font-medium text-zinc-900 dark:text-zinc-100">
                      Install as an app
                    </p>
                    <p className="text-sm text-muted">
                      Launch Foundation from your home screen or dock, like a native app.
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  disabled={installing}
                  onClick={handleInstall}
                  className={`${BUTTON_PRIMARY} shrink-0`}
                >
                  {installing ? 'Installing…' : 'Install'}
                </button>
              </div>
            )}
          </GlassCard>
        </SurfacePageBody>
      </Commentable>
    </SurfacePageLayout>
  );
}
